<script setup lang="ts" generic="T extends { value: string, label: string }">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

defineProps<{
  title: string
  options: T[]
  icon?: IconDefinition
}>()

const selected = defineModel<T[]>({ required: true })

function toggle(option: T) {
  const index = selected.value.findIndex(o => o.value === option.value)
  if (index === -1) {
    selected.value = [...selected.value, option]
  }
  else {
    selected.value = selected.value.filter(o => o.value !== option.value)
  }
}

function reset() {
  selected.value = []
}

defineExpose({ reset })
</script>

<template>
  <div class="w-full flex flex-col gap-s pb-s flex-1 min-h-0 overscroll-contain">
    <div class="flex items-center gap-2xs px-s">
      <Icon v-if="icon" :icon="icon" />
      <span class="text-small font-bold">{{ title }}</span>
    </div>

    <div class="flex flex-col gap-xs overflow-y-auto scrollbar-carbon flex-1 pb-2xl">
      <FormCheckboxRight
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :model-value="selected.some(a => a.value === option.value)"
        @update:model-value="toggle(option)"
      />
    </div>
  </div>
</template>
